/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UploadDeviceLogs } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Logs<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name LogsCreate
   * @request POST:/logs
   */
  logsCreate = (data: UploadDeviceLogs, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/logs`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
